export default [
  {
    title: "Dashboard",
    route: "dashboard-ecommerce",
    icon: "HomeIcon",
  },
  // {
  //   title: "Second Page",
  //   route: "second-page",
  //   icon: "DatabaseIcon",
  // },
  {
    title: "Produit",
    route: "",
    icon: "DatabaseIcon",
    children: [
      {
        title: "Stock",
        route: null,
        children: [
          {
            title: "Liste des produits",
            route: "stock",
          },
          {
            title: "Ajouter un produit",
            route: "add-stock",
          },
        ]
      },
      {
        title: "Catégorie",
        route: "categorie",
      },
      {
        title: "Sous catégorie",
        route: "subCategorie",
      },
    ],
  },
  {
    title: "Ventes",
    route: "",
    icon: "ClipboardIcon",
    children: [
      {
        title: "Devis",
        route: "",
        icon: "FileIcon",
        children: [
          {
            title: "Liste des devis",
            route: "sale-quote",
          },
          {
            title: "Ajouter un devis",
            route: "add-sale-quote",
          },
        ]
      },
      {
        title: "Commande",
        route: "",
        icon: "FileIcon",
        children: [
          {
            title: "Liste des commandes",
            route: "sale-command",
          },
          {
            title: "Ajouter une commande",
            route: "add-sale-command",
          },
        ]
      },
      {
        title: "Facture",
        route: "",
        icon: "FileIcon",
        children: [
          {
            title: "Liste des facture",
            route: "sale-invoice",
          },
          {
            title: "Ajouter une facture",
            route: "add-sale-invoice",
          },
        ]
      },
    ],
  },
  {
    title: "Achats",
    route: "table-bs-table",
    icon: "EditIcon",
    children: [
      {
        title: "Devis",
        route: "",
        icon: "FileIcon",
        children: [
          {
            title: "Liste des devis",
            route: "shop-quote",
          },
          // {
          //   title: "Ajouter une devis",
          //   route: "add-shop-quote",
          // },
        ]
      },
      {
        title: "Commande",
        route: "",
        icon: "FileIcon",
        children: [
          {
            title: "Liste des commandes",
            route: "shop-command",
          },
          {
            title: "Ajouter une commande",
            route: "add-shop-command",
          },
          {
            title: "Bons de commandes",
            route: "shop-purchase-order",
          },
        ]
      },
      {
        title: "Facture",
        route: "",
        icon: "FileIcon",
        children: [
          {
            title: "Liste des factures",
            route: "shop-invoice",
          },
          {
            title: "Ajouter une facture",
            route: "add-shop-invoice",
          },
        ]
      },
    ],
  },
  {
    title: "Prospect",
    icon: "UserXIcon",
    children: [
      {
        title: "Liste des prospects",
        route: "prospect",
      },
      {
        title: "Ajouter un prospect",
        route: "add-prospect",
      },
    ],
  },
  {
    title: "Client",
    icon: "UserPlusIcon",
    children: [
      {
        title: "Liste des clients",
        route: "client",
      },
      {
        title: "Ajouter un client",
        route: "add-client",
      },
    ],
  },
  {
    title: "Fournisseur",
    icon: "UserCheckIcon",
    children: [
      {
        title: "Liste des fournisseur",
        route: "supplier",
      },
      {
        title: "Ajouter un fournisseur",
        route: "add-supplier",
      },
    ],
  },
  {
    title: "Paramètre",
    icon: "SettingsIcon",
    route: "settings",
  },
  {
    title: "Offre",
    icon: "CreditCardIcon",
    route: "price",
  },
  {
    title: "FAQ",
    icon: "HelpCircleIcon",
    route: "faq",

  },
  // {
  //   title: "table1",
  //   route: "table-good-table",
  //   icon: "FileIcon",
  // },
  // {
  //   title: "table2",
  //   route: "table-bs-table",
  //   icon: "FileIcon",
  // },
];
